import { render, staticRenderFns } from "./StatisticsDocDownload.vue?vue&type=template&id=71efbe5a&"
import script from "./StatisticsDocDownload.vue?vue&type=script&lang=js&"
export * from "./StatisticsDocDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports